// Seletores de conversa (encaminhar mensagem, vincular conversa ao card,
// agendar mensagem). Antes cada um baixava TODAS as conversas página a página
// antes de abrir: conta grande fazia centenas de requisições em sequência, e o
// encaminhar nem terminava (a API usada ignorava a página). Agora o seletor
// abre com as mais recentes e a busca vai ao servidor.
import ConversationInboxAPI from 'dashboard/api/inbox/conversation';

export const PICKER_PAGE_SIZE = 25;
export const PICKER_MAX_PAGES = 4;

const payloadOf = response => response?.data?.data?.payload ?? [];

export const mergeUniqueConversations = (...lists) => {
  const seen = new Set();
  return lists.flat().filter(conversation => {
    const key = String(conversation?.id);
    if (!conversation || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// As conversas mais recentes (até PICKER_MAX_PAGES páginas), sem repetir.
export const fetchRecentConversations = async ({
  api = ConversationInboxAPI,
  maxPages = PICKER_MAX_PAGES,
} = {}) => {
  let all = [];
  for (let page = 1; page <= maxPages; page += 1) {
    // Sequencial de propósito: a próxima página só vale se esta veio cheia.
    // eslint-disable-next-line no-await-in-loop
    const payload = payloadOf(await api.get({ page }));
    all = mergeUniqueConversations(all, payload);
    if (payload.length < PICKER_PAGE_SIZE) break;
  }
  return all;
};

// Busca no servidor por nome, telefone ou número da conversa (1ª página).
export const searchConversations = async ({
  q,
  api = ConversationInboxAPI,
} = {}) => {
  const query = String(q || '').trim();
  if (!query) return [];
  return payloadOf(await api.get({ page: 1, q: query }));
};
